import { NgModule, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from '@openng/optimus-ui/accordion';
import { ConfirmationService, FilterMatchMode, FilterService, MessageService, Translation, TreeDragDropService } from '@openng/optimus-ui/api';
import { AutoCompleteModule } from '@openng/optimus-ui/autocomplete';
import { AvatarModule } from '@openng/optimus-ui/avatar';
//import { AvatarGroupModule } from '@openng/optimus-ui/avatargroup';
import { BadgeModule } from '@openng/optimus-ui/badge';
//import { BlockUIModule } from '@openng/optimus-ui/blockui';
import { BreadcrumbModule } from '@openng/optimus-ui/breadcrumb';
import { ButtonModule } from '@openng/optimus-ui/button';
import { CardModule } from '@openng/optimus-ui/card';
//import { CarouselModule } from '@openng/optimus-ui/carousel';
import { CascadeSelect, CascadeSelectModule } from '@openng/optimus-ui/cascadeselect';
//import {ChartModule} from '@openng/optimus-ui/chart';
import { CheckboxModule } from '@openng/optimus-ui/checkbox';
import { ChipModule } from '@openng/optimus-ui/chip';
//import { CodeHighlighterModule } from '@openng/optimus-ui/codehighlighter';
//import { ColorPickerModule } from '@openng/optimus-ui/colorpicker';
//import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog';
import { ConfirmPopupModule } from '@openng/optimus-ui/confirmpopup';
import { ContextMenuModule } from '@openng/optimus-ui/contextmenu';
//import { DataViewModule } from '@openng/optimus-ui/dataview';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { DividerModule } from '@openng/optimus-ui/divider';
import { DialogService } from '@openng/optimus-ui/dynamicdialog';
import { FieldsetModule } from '@openng/optimus-ui/fieldset';
//import { FileUploadModule } from '@openng/optimus-ui/fileupload';
//import { GalleriaModule } from '@openng/optimus-ui/galleria';
//import { InplaceModule } from '@openng/optimus-ui/inplace';
import { InputGroupModule } from '@openng/optimus-ui/inputgroup';
import { InputGroupAddonModule } from '@openng/optimus-ui/inputgroupaddon';
import { InputMaskModule } from '@openng/optimus-ui/inputmask';
import { InputNumberModule } from '@openng/optimus-ui/inputnumber';
import { InputTextModule } from '@openng/optimus-ui/inputtext';
//import { LightboxModule } from '@openng/optimus-ui/lightbox';
import { ListboxModule } from '@openng/optimus-ui/listbox';
//import { MegaMenuModule } from '@openng/optimus-ui/megamenu';
import { MenuModule } from '@openng/optimus-ui/menu';
//import { MenubarModule } from '@openng/optimus-ui/menubar';
import { MessageModule } from '@openng/optimus-ui/message';
import { MultiSelectModule } from '@openng/optimus-ui/multiselect';
import { OrderListModule } from '@openng/optimus-ui/orderlist';
//import { OrganizationChartModule } from '@openng/optimus-ui/organizationchart';
//import { PaginatorModule } from '@openng/optimus-ui/paginator';
import { PanelModule } from '@openng/optimus-ui/panel';
//import { PanelMenuModule } from '@openng/optimus-ui/panelmenu';
import { PasswordModule } from '@openng/optimus-ui/password';
//import { PickListModule } from '@openng/optimus-ui/picklist';
import { PopoverModule } from '@openng/optimus-ui/popover';
import { ProgressBarModule } from '@openng/optimus-ui/progressbar';
import { ProgressSpinnerModule } from '@openng/optimus-ui/progressspinner';
import { RadioButtonModule } from '@openng/optimus-ui/radiobutton';
import { RatingModule } from '@openng/optimus-ui/rating';
//import { ScrollPanelModule } from '@openng/optimus-ui/scrollpanel';
import { SelectButtonModule } from '@openng/optimus-ui/selectbutton';
//import { SlideMenuModule } from '@openng/optimus-ui/slidemenu';
import { SliderModule } from '@openng/optimus-ui/slider';
import { SpeedDialModule } from '@openng/optimus-ui/speeddial';
import { SplitButtonModule } from '@openng/optimus-ui/splitbutton';
import { SplitterModule } from '@openng/optimus-ui/splitter';
//import { StepperModule } from '@openng/optimus-ui/stepper';
//import { StepsModule } from '@openng/optimus-ui/steps';
import { TableModule } from '@openng/optimus-ui/table';
//import { TabMenuModule } from '@openng/optimus-ui/tabmenu';
import { TabsModule } from '@openng/optimus-ui/tabs';
import { TagModule } from '@openng/optimus-ui/tag';
//import { TerminalModule } from '@openng/optimus-ui/terminal';
import { TextareaModule } from '@openng/optimus-ui/textarea';
//import { TieredMenuModule } from '@openng/optimus-ui/tieredmenu';
import { TimelineModule } from '@openng/optimus-ui/timeline';
import { ToastModule } from '@openng/optimus-ui/toast';
//import { ToggleButtonModule } from '@openng/optimus-ui/togglebutton';
import { ToggleSwitchModule } from '@openng/optimus-ui/toggleswitch';
import { ToolbarModule } from '@openng/optimus-ui/toolbar';
import { TooltipModule } from '@openng/optimus-ui/tooltip';
import { TreeModule } from '@openng/optimus-ui/tree';
import { TreeTableModule } from '@openng/optimus-ui/treetable';
//import { VirtualScrollerModule } from '@openng/optimus-ui/virtualscroller';
import { TippyDirective } from '@ngneat/helipopper';
import { ColorSketchModule } from 'ngx-color/sketch';
import { AutoFocus, AutoFocusModule } from '@openng/optimus-ui/autofocus';
import { Optimus } from '@openng/optimus-ui/config';
import { DatePickerModule } from '@openng/optimus-ui/datepicker';
import { SelectModule } from '@openng/optimus-ui/select';
import { MainAppService } from '../app-template/services/main-app.service';
import { DatePickerKeyboardDirective } from "./directives/date-picker-keyboard.directive";
import { DynamicTooltipDirective } from './directives/dynamic-tooltip.directive';
import { DropdownMultiWordFilterDirective } from "./directives/dropdown-multi-word-filter.directive";
import { MultiWordFilter } from "../utils/misc/multi-word-filter";

@NgModule({
    declarations: [
        DatePickerKeyboardDirective,
        DropdownMultiWordFilterDirective,
        DynamicTooltipDirective
    ],
    imports: [
        AccordionModule,
        AvatarModule,
//        AvatarGroupModule,
        AutoCompleteModule,
        AutoFocusModule,
        BadgeModule,
//        BlockUIModule,
        BreadcrumbModule,
        ButtonModule,
        CardModule,
//        CarouselModule,
        CascadeSelectModule,
//        ChartModule,
        CheckboxModule,
        ChipModule,
//        CodeHighlighterModule,
//        ConfirmDialogModule,
        ConfirmPopupModule,
//        ColorPickerModule,
        ContextMenuModule,
//        DataViewModule,
        DatePickerModule,
        DividerModule,
        DialogModule,
        FieldsetModule,
//        FileUploadModule,
//        GalleriaModule,
//        InplaceModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputMaskModule,
        InputNumberModule,
        InputTextModule,
//        LightboxModule,
        ListboxModule,
//        MegaMenuModule,
        MenuModule,
//        MenubarModule,
        MessageModule,
        MultiSelectModule,
        OrderListModule,
//        OrganizationChartModule,
//        PaginatorModule,
        PanelModule,
//        PanelMenuModule,
        PasswordModule,
//        PickListModule,
        PopoverModule,
        ProgressBarModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        RatingModule,
//        ScrollPanelModule,
        SelectModule,
        SelectButtonModule,
//        SlideMenuModule,
        SliderModule,
        SpeedDialModule,
        SplitButtonModule,
        SplitterModule,
//        StepperModule,
//        StepsModule,
        TableModule,
//        TabMenuModule,
        TabsModule,
        TagModule,
//        TerminalModule,
        TextareaModule,
//        TieredMenuModule,
        TimelineModule,
        ToastModule,
//        ToggleButtonModule,
        ToggleSwitchModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
//        VirtualScrollerModule
        FormsModule,
        TippyDirective,
        ColorSketchModule
    ],
    exports: [
        AccordionModule,
        AutoCompleteModule,
        AutoFocusModule,
        AvatarModule,
//        AvatarGroupModule,
        BadgeModule,
//        BlockUIModule,
        BreadcrumbModule,
        ButtonModule,
        CardModule,
//        CarouselModule,
        CascadeSelectModule,
//        ChartModule,
        CheckboxModule,
        ChipModule,
//        CodeHighlighterModule,
//        ConfirmDialogModule,
        ConfirmPopupModule,
//        ColorPickerModule,
        ContextMenuModule,
//        DataViewModule,
        DatePickerModule,
        DatePickerKeyboardDirective,
        DialogModule,
        DividerModule,
        DynamicTooltipDirective,
        DropdownMultiWordFilterDirective,
        FieldsetModule,
//        FileUploadModule,
//        GalleriaModule,
//        InplaceModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputMaskModule,
        InputNumberModule,
        InputTextModule,
//        LightboxModule,
        ListboxModule,
//        MegaMenuModule,
        MenuModule,
//        MenubarModule,
        MessageModule,
        MultiSelectModule,
        OrderListModule,
//        OrganizationChartModule,
//        PaginatorModule,
        PanelModule,
//        PanelMenuModule,
        PasswordModule,
//        PickListModule,
        PopoverModule,
        ProgressBarModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        RatingModule,
//        ScrollPanelModule,
        SelectModule,
        SelectButtonModule,
//        SlideMenuModule,
        SliderModule,
        SpeedDialModule,
        SplitButtonModule,
        SplitterModule,
//        StepsModule,
//        StepperModule,
        TableModule,
//        TabMenuModule,
        TabsModule,
        TagModule,
//       TerminalModule,
        TextareaModule,
//        TieredMenuModule,
        TimelineModule,
        ToastModule,
//        ToggleButtonModule,
        ToggleSwitchModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
//        VirtualScrollerModule
        FormsModule,
        TippyDirective,
        ColorSketchModule
    ],
    providers: [
        AutoFocus,
        CascadeSelect,
        ConfirmationService,
        DialogService,
        MessageService,
        TreeDragDropService
    ]
})
export class PrimeModule {

    static instance: PrimeModule;

    config = inject(Optimus);
    app = inject(MainAppService);
    filterService = inject(FilterService);

    constructor() {
        PrimeModule.instance = this;
        let contains = this.filterService.filters[FilterMatchMode.CONTAINS];
        this.filterService.register(MultiWordFilter.matchMode, (value, filter, filterLocale) => MultiWordFilter.getWords(filter).every(word => contains(value, word, filterLocale)));
        
        this.config.filterMatchModeOptions = {
            text: [
                FilterMatchMode.CONTAINS,
                FilterMatchMode.EQUALS,
                FilterMatchMode.NOT_EQUALS,
                FilterMatchMode.STARTS_WITH,
                FilterMatchMode.NOT_CONTAINS,
                FilterMatchMode.ENDS_WITH
            ],
            numeric: [
                FilterMatchMode.EQUALS,
                FilterMatchMode.NOT_EQUALS,
                FilterMatchMode.LESS_THAN,
                FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
                FilterMatchMode.GREATER_THAN,
                FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
            ],
            date: [
                FilterMatchMode.DATE_IS,
                FilterMatchMode.DATE_IS_NOT,
                FilterMatchMode.DATE_BEFORE,
                FilterMatchMode.DATE_AFTER
            ]
        };
    }

    setLanguage(language: string): void {
        if (language != "en") {
            this.config.setTranslation(this.app.getTranslationMap().primeng as Translation);
        }
    }

}
